import { useAtomValue } from "jotai";
import isUndefined from "lodash/isUndefined";
import { DialogHandlerStore } from "../../stores/dialog-handler-store";
import { EmptyComponent } from "../common/EmptyComponent";

export function DialogHandler(): JSX.Element {
  const { dialogComponent } = useAtomValue(DialogHandlerStore);

  if (isUndefined(dialogComponent)) return <EmptyComponent />;

  return <>{dialogComponent}</>;
}
